var map = {
	"./de/btn-view.png": "s2WF",
	"./en/btn-view.png": "Td4F",
	"./es/btn-view.png": "SVM8",
	"./fr/btn-view.png": "hC4w",
	"./ja/btn-view.png": "IovB",
	"./ko/btn-view.png": "iiKl",
	"./pt/btn-view.png": "9DnZ",
	"./ru/btn-view.png": "vnzM",
	"./tc/btn-view.png": "dyDh",
	"./th/btn-view.png": "UVDD"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "C1YB";